// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { copySystemGrid as copySystemGridAction, removeSystemGrid as removeSystemGridAction } from '../actions/basket';
import GridsSystemActions from '../components/pool/GridsSystemActions';

const legacySelector = memoize((state) => ({
  isSystem: state.grids.basket.isSystem,
}));

type GridsSystemActionsContainerProps = {
  className?: string;
  selectionIndex: number;
};

const GridsSystemActionsContainer = ({ selectionIndex, ...ownProps }: GridsSystemActionsContainerProps) => {
  const dispatch = useDispatch();
  const selectedProps = useSelector(legacySelector);

  const copySystemGrid = useCallback(() => {
    dispatch(copySystemGridAction(selectionIndex));
  }, [dispatch, selectionIndex]);

  const removeSystemGrid = useCallback(() => {
    dispatch(removeSystemGridAction(selectionIndex));
  }, [dispatch, selectionIndex]);

  const otherProps = useMemo(
    () => ({
      copySystemGrid,
      removeSystemGrid,
    }),
    [copySystemGrid, removeSystemGrid],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <GridsSystemActions {...enhancedProps} />;
};

export default GridsSystemActionsContainer;
